// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1118":"4b7e955c","6640":"de680643","7904":"8d9dbb11"}[chunkId] + ".chunk.css";
};